<form [formGroup]="form">

<div class="modal-header">
    <h4 class="modal-title">Opgave</h4>
    <button (click)="onClose()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">

    <div class="row">
        <div class="col-sm-12 mb-3">
            <label><small>Overskrift</small></label>
            <input class="form-control form-control-sm" formControlName="tekst" />
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 mb-3">
            <label><small>Beskrivelse</small></label>
            <textarea
                autosize
                [minHeight]="60"
                class="form-control form-control-sm"
                formControlName="beskrivelse"
            ></textarea>
        </div>
    </div>

    <div class="mb-3 row">
        <label class="col-sm-4 col-form-label col-form-label-sm">Opgaveopretter</label>
        <div class="col-sm-8">
            <input disabled class="form-control form-control-sm" [value]="getUsername(task?.mid)" />
        </div>
    </div>

    <div class="mb-3 row">
        <label for="assignee" class="col-sm-4 col-form-label col-form-label-sm">Opgaveløser</label>
        <div class="col-sm-8">
            <select class="form-select form-select-sm" id="assignee" formControlName="fup">
                <option disabled selected value="0"> -- Ingen -- </option>
                <option *ngFor="let user of taskUsers" [value]="user.cardId">{{user.navn}}</option>
            </select>
        </div>
    </div>

    <div class="mb-3 row">
        <label for="deadline" class="col-sm-4 col-form-label col-form-label-sm">Deadline</label>
        <div class="col-sm-8">
            <app-date-picker-dk
                class="col-sm-8 p-0"
                [disable]="!edit"
                [minDate]="today"
                id="deadline"
                formControlName="deadline">
            </app-date-picker-dk>
        </div>
    </div>

    <div *ngIf="task?.afsluttet" class="mb-3 row">
        <label class="col-sm-4 col-form-label col-form-label-sm">Afsluttet</label>
        <div class="col-sm-8">
            <input disabled class="form-control form-control-sm" value="{{ task.afsluttet.toString() | dateUtc:'dd-LL-yyyy' }}" />
        </div>
    </div>

    <div *ngIf="task && !edit" class="row">
        <div class="col-sm-12">

            <div class="row clickable" (click)="showComments = !showComments">
                <small class="col-10 float-start">Kommentarer / historik ({{ sortedTaskComments?.length }})</small>
                <small class="col-2"><i class="float-end pe-2" [ngClass]="showComments ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i></small>
            </div>

            <ng-container *ngIf="showComments">

                <div *ngFor="let comment of sortedTaskComments" class="row p-2">
                    <div class="col-sm-12 task-comment">
                        <div class="row">
                            <div class="col-sm-12">
                                <small>
                                    {{ comment.created | dateUtc:'dd-LL-yyyy HH:mm'}}<br>
                                    {{ commentHeader(comment) }}
                                </small>
                            </div>
                        </div>
                        <div *ngIf="comment.comment" class="row">
                            <div class="col-sm-12">
                                {{ comment.type === 'assign' ? '' : comment.comment }}
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!task.afsluttet && !showDone && !showReject" class="row">
                    <div *ngIf="commenting; else newCommentButton" class="col-sm-12 mb-3">
                        <label><small>Ny kommentar</small></label>
                        <textarea
                            #commentText
                            autosize
                            [minHeight]="30"
                            class="form-control form-control-sm"
                        ></textarea>
                        <div class="btn-toolbar float-end mb-2">
                            <button (click)="commenting = !commenting" class="btn btn-sm btn-primary me-2 mt-2" type="button">Annuller</button>
                            <button (click)="newComment(commentText.value)" class="btn btn-sm btn-primary mt-2" type="button">Send</button>
                        </div>
                    </div>
                    <ng-template #newCommentButton>
                        <div class="col-sm-12">
                            <div class="btn-toolbar float-end">
                                <button (click)="commenting = !commenting" class="btn btn-sm btn-primary mt-2" type="button">Ny kommentar</button>
                            </div>
                        </div>
                    </ng-template>
                </div>

            </ng-container>

            <div *ngIf="showDone" class="row">
                <div class="col-sm-12 mb-3">
                    <label><small>Afsluttende kommentar (valgfri)</small></label>
                    <textarea
                        #doneText
                        autosize
                        [minHeight]="30"
                        class="form-control form-control-sm"
                    ></textarea>
                    <div class="btn-toolbar float-end mb-2">
                        <button (click)="showDone = false" class="btn btn-sm btn-primary me-2 mt-2" type="button">Annuller</button>
                        <button (click)="onDone(doneText.value)" class="btn btn-sm btn-success mt-2" type="button">Afslut</button>
                    </div>
                </div>
            </div>

            <div *ngIf="showReject" class="row">
                <div class="col-sm-12 mb-3">
                    <label><small>Afvisningsårsag (valgfri)</small></label>
                    <textarea
                        #rejectText
                        autosize
                        [minHeight]="30"
                        class="form-control form-control-sm"
                    ></textarea>
                    <div class="btn-toolbar float-end mb-2">
                        <button (click)="showReject = false" class="btn btn-sm btn-primary me-2 mt-2" type="button">Annuller</button>
                        <button (click)="onReject(rejectText.value)" class="btn btn-sm btn-danger mt-2" type="button">Afvis</button>
                    </div>
                </div>
            </div>

        </div>
    </div>


</div>

<div *ngIf="!showDone && !showReject" class="modal-footer">
    <div class="btn-toolbar float-end mb-2">
        <button *ngIf="edit" (click)="onEditCancel()" class="btn btn-primary me-2" type="button">Annuller</button>
        <button *ngIf="edit" (click)="onSave()" class="btn btn-primary me-2" type="submit">Gem</button>
        <button *ngIf="!edit && canDelete" (click)="onDelete()" class="btn btn-danger me-2" type="button">Slet</button>
        <button *ngIf="!edit && canEdit" (click)="onEdit()" class="btn btn-primary me-2" type="button">Rediger</button>
        <button *ngIf="!edit && canDone" (click)="showReject = !showReject; showDone = false" class="btn btn-danger me-2" type="button">
            <i class="fa fa-ban"></i>
        </button>
        <button *ngIf="!edit && canDone" (click)="showDone = !showDone; showReject = false" class="btn btn-success me-2" type="button">
            <i class="fa fa-check"></i>
        </button>
    </div>
</div>

</form>
